import { useMemo, useState, useEffect, useCallback } from 'react';

/**
 * API sayfalama alanları (TR / EN) tek forma
 * @returns {{ total: number, totalPages: number, mevcutSayfa: number, limit: number }}
 */
export const normalizeSayfalama = (s, fallbackLimit = 25) => ({
  total: s?.toplam ?? s?.total ?? s?.toplamKayit ?? 0,
  totalPages: Math.max(1, s?.toplamSayfa ?? s?.totalPages ?? 1),
  mevcutSayfa: s?.mevcutSayfa ?? s?.currentPage ?? s?.sayfa ?? 1,
  limit: s?.limit ?? fallbackLimit,
});

export const clampPage = (page, totalPages) => {
  const tp = Math.max(1, totalPages || 1);
  return Math.min(Math.max(1, page), tp);
};

/**
 * İstemci taraflı sayfalama (detay modalları, küçük listeler)
 */
export function useClientPagination(items, pageSize = 10) {
  const [page, setPage] = useState(1);
  const list = Array.isArray(items) ? items : [];
  const total = list.length;
  const totalPages = Math.max(1, Math.ceil(total / pageSize) || 1);

  useEffect(() => {
    if (page > totalPages) {
      setPage(totalPages);
    }
  }, [page, totalPages]);

  const pageItems = useMemo(() => {
    const start = (page - 1) * pageSize;
    return list.slice(start, start + pageSize);
  }, [list, page, pageSize]);

  const resetPage = useCallback(() => setPage(1), []);

  return {
    page,
    setPage,
    pageItems,
    totalPages,
    total,
    pageSize,
    resetPage,
  };
}
